import {useTranslation} from '@aboutyou/i18n';
import {
  ProductColorOptions,
  ProductColorOptionsProps,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useInlineSizeSelectionQuickViewAB} from '../AddToBasketQuickView/hooks/useInlineSizeSelectionQuickViewAB';
import {ProductSelectionViewProps} from './ProductSelectionView';

export const ProductSelectionHorizontal: React.FC<
  Omit<
    ProductSelectionViewProps,
    'ColorSelectionLayoutComponent' | 'SoldOutComponent'
  > & {
    colorOptions: ProductColorOptionsProps['options'];
    shouldUseSquareProductImages?: boolean;
  }
> = ({
  className,
  colorOptions,
  disablePreviewImage,
  disableRedirect,
  setPreviewImage,
  shouldUseSquareProductImages,
  hideHeader,
}) => {
  const {t} = useTranslation();
  const isInlineSizeSelectionQuickViewAB = useInlineSizeSelectionQuickViewAB();

  return (
    <Container className={className} data-testid="product-selection">
      {colorOptions && (
        <ProductColorOptions
          data-testid="productColorOptions"
          label={t('Colour')}
          options={colorOptions}
          disablePreviewImage={disablePreviewImage}
          disableRedirect={disableRedirect}
          setPreviewImage={setPreviewImage}
          shouldUseSquareProductImages={shouldUseSquareProductImages}
          hideHeader={hideHeader}
          isSmallerHeader={isInlineSizeSelectionQuickViewAB}
        />
      )}
    </Container>
  );
};

const Container = styled.section``;
